import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://zakkxzsmvlyuskrzslrs.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpha2t4enNtdmx5dXNrcnpzbHJzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAwNzgzNjYsImV4cCI6MjA3NTY1NDM2Nn0.aNj2fkhJGeKfpQNwspKVc_-DCFc40-hM68ISTUozwQs'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)